import { KeyboardKeyEnum } from '@/core/enums';
import { Directive, ElementRef, HostListener, inject } from '@angular/core';


@Directive({
  selector: '[numberOnly]',
  standalone: true,
})
export class NumberOnlyDirective {
  private el = inject(ElementRef<HTMLInputElement>);

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valorLimpio = input.value.replace(/[^0-9]/g, '');
    
    if (input.value !== valorLimpio) {
      input.value = valorLimpio;
      // Notifica a Angular del cambio
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const teclasPermitidas = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'
    ];

    const input = event.target as HTMLInputElement;

    if (event.key === KeyboardKeyEnum.ArrowUp) {
      input.value = String(Number(input.value) + 1);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    if (event.key === KeyboardKeyEnum.ArrowDown) {
      if (input.value === "0") return;

      input.value = String(Number(input.value) - 1);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    if (teclasPermitidas.includes(event.key)) return;
    
    if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
      return;
    }
    
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const texto = event.clipboardData?.getData('text') ?? '';
    if (!/^[0-9]+$/.test(texto)) {
      event.preventDefault();
    }
  }
}
